// extracted by mini-css-extract-plugin
module.exports = {"lang":"styles_lang__1bEvp","langBtn":"styles_langBtn__fwz90","icon":"styles_icon__UFfTX"};